<template>
 <div class="product">
  <div class="product-container" v-show="!info_show">
   <Header></Header>
   <Tabs @viewDetails="viewDetails"></Tabs>
   <div class="product-box">
   </div>
  </div>
  <div class="product-info-pc">
   <Info v-if="info_show" :list="_list" :itemInfo="itemInfo" @changeItem="changeItem" @close="close"></Info>
  </div>
  <div class="product-info-mobile">
   <InfoMobile v-if="info_show" :list="_list" :itemInfo="itemInfo" @changeItem="changeItem" @close="close">
   </InfoMobile>
  </div>
 </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, onUnmounted } from "vue"
import Header from "./header.vue"
import Tabs from "./tabs.vue"
import Info from "./components/info.vue"
import InfoMobile from "./components/infoMobile.vue"
import { useRoute } from "vue-router"
import { getFilterList } from "@/api/index.js"
import emitter from '@/assets/js/eventBus.js';


const info_show = ref(false)

const itemInfo = ref()
const _list = ref([])
const route = useRoute()

const viewDetails = (data, list) => {

 if (data.input988275a1 === "MAPaaS" || data.input988275a1 === "零代码产品" || data.input988275a1 === "畅图云" || data.rowId === "68394af4a4f28e50361ef896") {
  window.open("https://platform.mapaas.com/home")
 } else {

  itemInfo.value = data

  let list_data = []
  list.forEach(item => {
   if (item.input988275a1 === "MAPaaS" || item.input988275a1 === "零代码产品" || item.input988275a1 === "畅图云" || item.rowId === "68394af4a4f28e50361ef896") {

   } else {
    list_data.push(item)
   }
  })
  list_data.sort(function (a, b) {
   return a.number68b2284b - b.number68b2284b;
  });
  _list.value = list_data
  info_show.value = true
 }

}

const changeItem = (data) => {
 itemInfo.value = data
}

const close = () => {
 info_show.value = false
}
const rowId = computed(() => {
 return route.query.rowId
})
const groupId = computed(() => {
 return route.query.groupId
})

const openInfo = async () => {
 let params = {
  page: 1,
  pageSize: 100,
  worksheetId: "680f487788d915058691f9f8",
  filters: [
   {
    "dataType": 0,
    "field": "rowId",
    "spliceType": 0,
    "values": [
     rowId.value
    ],
    "isDynamicSource": false,
    "dynamicSource": [],
    "filterType": 2
   }
  ]
 }
 const res = await getFilterList(params)
 let _params = {
  page: 1,
  pageSize: 100,
  worksheetId: "680f487788d915058691f9f8",
 }
 const _res = await getFilterList(_params)
 if (_res.code === 200 && _res.data && _res.data.length > 0 && res.code === 200 && res.data && res.data.length > 0) {

  viewDetails(res.data[0], _res.data)
 }
}

watch(() => rowId.value, (newVal) => {
 if (rowId.value) {
  openInfo()
 } else {
  close()
 }
}, { deep: true })

const closeIfdoFunction = () => {
 close()

}

onMounted(() => {


 emitter.on("close-info-product", closeIfdoFunction)

 if (rowId.value) {
  openInfo()
 } else {
  close()
 }
})

onUnmounted(() => {
 emitter.off("close-info-product", closeIfdoFunction)
})


</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .product-info-pc {
  display: none;
 }

 .product-info-mobile {
  display: block;
 }
}



@media screen and (min-width: 800px) {
 .product-info-pc {
  display: block;
 }

 .product-info-mobile {
  display: none;
 }
}

.product {
 width: 100%;
 height: 100%;

}

.product-container {
 width: 100%;
 height: 100%;
}

.product-box {
 width: 1920px;
 display: flex;
 justify-content: center;
}

.product-info-pc {
 width: 100%;
 height: 100%;
}

.product-info-mobile {
 width: 100%;
 height: 100%;
}
</style>